<template>
  <div>
    <div style="position: relative;min-height: 200px">
      <v-container>
        <div v-if="loading" class="text-xs-center">
          <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
        </div>
        <template v-else>
          <v-text-field
            name="Search"
            label="Search"
            v-model="search"
            clearable
            single-line
            prepend-inner-icon="search"
            outline
          ></v-text-field>
          <h3 class="headline mb-3">Local Variable in {{ $store.state.selectedFlow.flowname }}</h3>
          <template v-for="variable in filterVariable">
            <div class="z-border-red mb-2 pa-2" :key="variable.id">
              <add-variable
                :value="variable"
                type="local"
                @onSave="onEdit"
                @onDelete="onDelete(variable.id)"
              ></add-variable>
            </div>
          </template>
          <template>
            <div
              class="add-conversation text-xs-center"
              style="cursor: pointer"
              @click="isAdd = true"
              v-if="!isAdd"
            >
              <i class="fa fa-plus middle"></i>
              {{ $t('Add local variable') }}
            </div>
            <div class="z-border-red mb-2 pa-2" v-else>
              <add-variable @onCancel="isAdd = false" type="local" @onSave="onSave"></add-variable>
            </div>
          </template>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapMutations } from 'vuex'
import AddVariable from './AddVariable'
export default {
  data() {
    return {
      isAdd: false,
      loading: true,
      search: ''
    }
  },
  components: {
    AddVariable
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList',
      selectedFlow: 'getFlowId'
    }),
    filterVariable() {
      var vm = this
      if (!this.selectedFlow) {
        return []
      }
      let variables = vm.variable.filter(el => {
        return el.flowid == this.selectedFlow.id
      })

      if (variables) {
        variables = variables.filter(el => {
          return el.name && el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      }

      return variables
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    onEdit(payload) {
      var vm = this
      this.isAdd = false
      vm.loading = true
      var data = payload
      api.editVariable(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadAllVariable').then(() => {
          vm.loading = false
        })
      })
    },
    onSave(payload) {
      var vm = this
      this.isAdd = false
      vm.loading = true
      var data = payload
      api.addVariable(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadAllVariable').then(() => {
          vm.loading = false
        })
      })
    },
    onDelete(id) {
      var vm = this
      var data = {
        id: id
      }
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            api.deleteVariable(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.loading = false
                return
              }
              vm.$store.dispatch('loadAllVariable').then(() => {
                vm.loading = false
              })
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/LocalVariableSetting.vue